import { ReducerCreators } from '@reduxjs/toolkit';
import { StoreLoading } from '../types';
import { Summary, SummaryStoreState } from './types';

export default (
  create: ReducerCreators<SummaryStoreState>
) => ({
  updateLoadingStatus: create.reducer<StoreLoading>(
    (state, { payload }) => {
      state.loading = payload;
    }
  ),
  updateSummary: create.reducer<Summary>(
    (state, { payload }) => {
      state.entity = payload;
      state.loading = 'succeeded';
    }
  )
});
